import { render, staticRenderFns } from "./FormBed.vue?vue&type=template&id=5e4128f7"
import script from "./FormBed.vue?vue&type=script&lang=js"
export * from "./FormBed.vue?vue&type=script&lang=js"
import style0 from "./FormBed.vue?vue&type=style&index=0&id=5e4128f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports